export class DataTableSearchModel {
  start: number = 0;
  length: number = 10;
}
